import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {

  constructor(public router:Router){

  }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    if ( sessionStorage.getItem('general_data') ) {
      console.log(sessionStorage.getItem('general_data'));
      return true;
      
    } else {
      console.log(sessionStorage.getItem('general_data'));
      this.router.navigate(['/registro'] );
      return false;
    }    
  }
  
}
